import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IConvert } from '../../../../models/evaluation.model'
import { doCreateConvert } from '../../../../store/convert.slice';
import { doRemoveAuth } from '../../../../store/auth.slice';
import { RootState } from '../../../../store/rootReducer';
import { useSnackbar } from 'notistack';
import qs from 'qs';

import Loader from '../../../../components/Loader';
import Header from '../../../../components/layout/Header';
import Footer from '../../../../components/layout/Footer';
import Editor from '../../../../components/program/convert/table/Editor';
import { successVariant, warningVariant, errorVariant } from '../../../../lib/barVariant';
import SimpleHeader from '../../../../components/layout/SimpleHeader';

interface IMatch {
  id: string;
}

const ProgramConvertTableCreate: FC<RouteComponentProps> = ({ history, location }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.convert);

  const match = useRouteMatch<IMatch>();
  const id = Number(match.params.id);
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const [name, setName] = useState('');

  useEffect(() => {
    // query to state
    if (query.name) setName(String(query.name));
  }, [location]);

  const onSubmit = async (req: IConvert) => {
    const res = await dispatch(doCreateConvert(id, req));

    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.create1'), successVariant);
        history.push(`/program/convert/${id}/table?name=${name}`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.program')}
        currentMenu={`${t('program.convert.title2')} - ${name}`}
      />
      <Editor
        convert={null}
        onSubmit={onSubmit}
        id={id}
        name={name}
      />
    </div>
  )
}

export default ProgramConvertTableCreate;
